import {
  FETCH_AUTH_REQUEST,
  FETCH_AUTH_SUCCESS,
  FETCH_AUTH_FAILURE,
  LOGOUT_AUTH,
  FETCH_SHORT_PIN_REQUEST,
  FETCH_SHORT_PIN_SUCCESS,
  FETCH_SHORT_PIN_FAILURE,
  FETCH_AUTH_PIN_REQUEST,
  FETCH_AUTH_PIN_SUCCESS,
  FETCH_AUTH_PIN_FAILURE,
} from "./action-types";

import { LoginActions, AuthState } from "./types";

const userStorage = localStorage.getItem("user");
const user = userStorage !== null ? JSON.parse(userStorage) : null;

const initialState: AuthState = userStorage
  ? {
      pending: false,
      isLoggedIn: true,
      user: user,
      short_pin_token: null,
      pincode: null,
      error: null,
      pinError: null,
    }
  : {
      pending: false,
      isLoggedIn: false,
      user: null,
      short_pin_token: null,
      pincode: null,
      error: null,
      pinError: null,
    };

export default (state = initialState, action: LoginActions) => {
  switch (action.type) {
    case FETCH_AUTH_REQUEST:
      return {
        ...state,
        isLoggedIn: false,
        pending: true,
      };
    case FETCH_AUTH_SUCCESS:
      return {
        ...state,
        pending: false,
        isLoggedIn: true,
        user: action.payload.user,
        error: null,
      };
    case FETCH_AUTH_FAILURE:
      return {
        ...state,
        pending: false,
        isLoggedIn: false,
        user: null,
        error: action.payload.error,
      };
    case FETCH_SHORT_PIN_REQUEST:
      return {
        ...state,
        isLoggedIn: true,
        pending: true,
      };
    case FETCH_SHORT_PIN_SUCCESS:
      return {
        ...state,
        pending: false,
        isLoggedIn: true,
        short_pin_token: action.payload.short_pin_token,
        pincode: action.payload.pincode,
        error: null,
      };
    case FETCH_SHORT_PIN_FAILURE:
      return {
        ...state,
        pending: false,
        isLoggedIn: true,
        error: action.payload.error,
      };
    case FETCH_AUTH_PIN_REQUEST:
      return {
        ...state,
        isLoggedIn: false,
        pending: true,
      };
    case FETCH_AUTH_PIN_SUCCESS:
      return {
        ...state,
        pending: false,
        isLoggedIn: true,
        user: action.payload.user,
        error: null,
      };
    case FETCH_AUTH_PIN_FAILURE:
      return {
        ...state,
        pending: false,
        isLoggedIn: false,
        user: null,
        pinError: action.payload.pinError,
      };
    case LOGOUT_AUTH:
      return {
        ...state,
        pending: false,
        isLoggedIn: false,
        user: null,
        error: null,
      };
    default:
      return {
        ...state,
      };
  }
};
